export enum COMPANY_ACCOUNT_TYPE {
  INTERMEDIARY = 'Intermediary',
  DIRECT = 'Direct'
}

export enum COMPANY_CATEGORY {
  SC = 'SC',
  IATA = 'IATA',
  RT = 'RT'
}
export enum COMPANY_TYPE {
  AGV = 'AGV',
  INDI = 'INDI',
  PP = 'PP',
  TO = 'TO',
  COMP = 'COMP'
}

export enum COMPANY_NUMBER_OF_EMPLOYEES {
  '0_100' = '0-100',
  '100_500' = '100-500',
  '500_2000' = '500-2000',
  '2000_10000' = '2000-10000',
  '10000_PLUS' = '10000+'
}

export enum COMPANY_ADDRESS_USAGE {
  POSTAL = 'Postal',
  BILLING = 'Billing'
}

export enum COMPANY_BUSINESS_LINE {
  AEROSPACEDEFENSE = 'AEROSPACEDEFENSE',
  ASSOCIATION = 'ASSOCIATION',
  AUDITCONSULTINGLEGAL = 'AUDITCONSULTINGLEGAL',
  AUTOMOTIVE = 'AUTOMOTIVE',
  BANKFINANCEINSURANCE = 'BANKFINANCEINSURANCE',
  DISTRIBUTION = 'DISTRIBUTION',
  ELECTRONICGOODS = 'ELECTRONICGOODS',
  ENERGYCHEMICAL = 'ENERGYCHEMICAL',
  FOODINDUSTRY = 'FOODINDUSTRY',
  LUXURYCOSMETIC = 'LUXURYCOSMETIC',
  MEORG = 'MEORG',
  MULTIMEDIACOMMUNICATION = 'MULTIMEDIACOMMUNICATION',
  PHARMACEUTICALHEALTH = 'PHARMACEUTICALHEALTH',
  REALESTATECONSTRUCTION = 'REALESTATECONSTRUCTION',
  SOFTWARECOMPUTINGDIGITAL = 'SOFTWARECOMPUTINGDIGITAL',
  SPORTCLUB = 'SPORTCLUB',
  TELECOMINTERNET = 'TELECOMINTERNET',
  TRANSPORTATION = 'TRANSPORTATION',
  OTHERINDUSTRIES = 'OTHERINDUSTRIES'
}

export const BUSINESS_LINE_MAP: Record<COMPANY_BUSINESS_LINE, string> = {
  [COMPANY_BUSINESS_LINE.AEROSPACEDEFENSE]:
    'aab.company.management.companyInfo.businessLine.aerospacedefense.label',
  [COMPANY_BUSINESS_LINE.ASSOCIATION]:
    'aab.company.management.companyInfo.businessLine.association.label',
  [COMPANY_BUSINESS_LINE.AUDITCONSULTINGLEGAL]:
    'aab.company.management.companyInfo.businessLine.auditconsultinglegal.label',
  [COMPANY_BUSINESS_LINE.AUTOMOTIVE]:
    'aab.company.management.companyInfo.businessLine.automotive.label',
  [COMPANY_BUSINESS_LINE.BANKFINANCEINSURANCE]:
    'aab.company.management.companyInfo.businessLine.bankfinanceinsurance.label',
  [COMPANY_BUSINESS_LINE.DISTRIBUTION]:
    'aab.company.management.companyInfo.businessLine.distribution.label',
  [COMPANY_BUSINESS_LINE.ELECTRONICGOODS]:
    'aab.company.management.companyInfo.businessLine.electronicgoods.label',
  [COMPANY_BUSINESS_LINE.ENERGYCHEMICAL]:
    'aab.company.management.companyInfo.businessLine.energychemical.label',
  [COMPANY_BUSINESS_LINE.FOODINDUSTRY]:
    'aab.company.management.companyInfo.businessLine.foodindustry.label',
  [COMPANY_BUSINESS_LINE.LUXURYCOSMETIC]:
    'aab.company.management.companyInfo.businessLine.luxurycosmetic.label',
  [COMPANY_BUSINESS_LINE.MEORG]: 'aab.company.management.companyInfo.businessLine.meorg.label',
  [COMPANY_BUSINESS_LINE.MULTIMEDIACOMMUNICATION]:
    'aab.company.management.companyInfo.businessLine.multimediacommunication.label',
  [COMPANY_BUSINESS_LINE.PHARMACEUTICALHEALTH]:
    'aab.company.management.companyInfo.businessLine.pharmaceuticalhealth.label',
  [COMPANY_BUSINESS_LINE.REALESTATECONSTRUCTION]:
    'aab.company.management.companyInfo.businessLine.realestateconstruction.label',
  [COMPANY_BUSINESS_LINE.SOFTWARECOMPUTINGDIGITAL]:
    'aab.company.management.companyInfo.businessLine.softwarecomputingdigital.label',
  [COMPANY_BUSINESS_LINE.SPORTCLUB]:
    'aab.company.management.companyInfo.businessLine.sportclub.label',
  [COMPANY_BUSINESS_LINE.TELECOMINTERNET]:
    'aab.company.management.companyInfo.businessLine.telecominternet.label',
  [COMPANY_BUSINESS_LINE.TRANSPORTATION]:
    'aab.company.management.companyInfo.businessLine.transportation.label',
  [COMPANY_BUSINESS_LINE.OTHERINDUSTRIES]:
    'aab.company.management.companyInfo.businessLine.otherindustries.label'
}
